import React, { useEffect, useState } from "react";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import { Col, Container, Row } from "react-bootstrap";
import InputField from "../component/InputField";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import PrimaryOutLineButton from "../component/PrimaryOutLineButton";
import SelectDropDown from "../component/SelectDropDown";
import UploadFile from "../component/UploadFile";
import OtherService from "../services/Other";
import AlertMsg from "../component/AlertMsg";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const LibraryUpload = () => {
    const navigate = useNavigate()
    const [titleValidationError, setTitleValidationError] = useState('')
    const [descriptionValidationError, setDescriptinValidationError] = useState('')
    const [documentTypeValidationError, setDocumentTypeValidationError] = useState('')
    const [documentValidationError, setDocumentValidationError] = useState('')
    const [isDocumentSelect, setIsDocumentSelect] = useState({ id: "", title: "" })
    const [isLoginSuccess, setIsLoginSuccess] = useState({ isLogin: true, heading: '', text: '' })
    const [showAlert, setShowAlert] = useState(false);
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const [uploadFile, setUploadFile] = useState(null)
    const [uploadFileData, setUploadFileData] = useState({
        title: '',
        description: ''
    })
    const documentType = [
        {
            title: 'Image',
            id: 'image',
        },
        {
            title: 'Document',
            id: 'document',
        },
        {
            title: 'Video',
            id: 'video',
        },

    ];
    const handleDocumentTypeChange = (selected) => {
        setIsDocumentSelect(selected)
        setDocumentTypeValidationError('')
    }
    const handleUploadInput = (e) => {
        setUploadFileData({ ...uploadFileData, [e.target.name]: e.target.value });
    }
    const handleUpload = async () => {
       
        let isValid = true;
        const validations = [
            {
                value: uploadFileData.title,
                setter: setTitleValidationError,
                message: "Title is required.",

            },
            {
                value: uploadFileData.description,
                setter: setDescriptinValidationError,
                message: "Description is required.",
            },
            {
                value: isDocumentSelect.id,
                setter: setDocumentTypeValidationError,
                message: "Document Type is required.",
            },
            {
                value: uploadFile,
                setter: setDocumentValidationError,
                message: "Document is required.",
            }
        ];
        validations.forEach(({ value, setter, message }) => {
            if (!value) {
                setter(message);
                isValid = false;
            } else {
                setter(""); // Clear the error message
            }
        });
        if (isValid) {
            try {
                setIsButtonLoading(true)
                const token = localStorage.getItem('access_token');
                const formData = new FormData();
                formData.append('title', uploadFileData.title);
                formData.append('description', uploadFileData.description);
                // formData.append('file_type', ' ');
                formData.append('file_type', isDocumentSelect.id);

                 
                // formData.append('docFile', uploadFile)
                formData.append("docFile", uploadFile.file);

                const DocUpload = await OtherService.uploadFile(formData)
                if (DocUpload?.success === true) {
                    setIsButtonLoading(false)
                    // setShowAlert(true)
                    // setIsLoginSuccess(
                    //     {
                    //         isSuccess: true,
                    //         text: DocUpload?.response?.message || "Upload successful"
                    //     }
                    // )
                    toast.success(DocUpload?.response?.message || "Upload successful")
                    setUploadFileData({
                        title: '',
                        description: ''
                    })
                    setIsDocumentSelect({
                        title: '',
                        id: '',
                    })
                    setUploadFile(null)

                }
                else {

                    setIsButtonLoading(false)
                    // setShowAlert(true)
                    // setIsLoginSuccess(
                    //     {
                    //         isSuccess: false,
                    //         text: DocUpload?.response?.message || "Something went wrong",
                    //     }
                    // )
                    toast.error(DocUpload?.response?.message || "Something went wrong")
                }
            }
            catch (error) {
                console.error('Library Upload')
            }
        }
    }

    const handleViewLibrary = () => {
        navigate('/document-library');

    }
    return (
        <>
            <BreadCrumbSecttion
                pageTitle="My Library Upload"
                currentPageName="My Library Upload"
            />
            <section className="padTop50">
                <Container>
                    <Row className="justify-content-center align-item-center h-100">
                        <Col xs={12}>
                            <div className="userInfoBox">
                                <div className="dashboard-title">
                                    <h4>Please Upload Document</h4>
                                </div>
                                <div className="dashboard-details">
                                    <Row>
                                        <Col xs={12} lg={3}>
                                            <InputField
                                                requiredStar="*"
                                                inputFieldLabel="Title"
                                                onChange={handleUploadInput}
                                                name="title"
                                                value={uploadFileData.title}
                                            />
                                            {titleValidationError && <div className="error-message">{titleValidationError}</div>}
                                        </Col>
                                        <Col xs={12} lg={3}>
                                            <InputField
                                                requiredStar="*"
                                                inputFieldLabel="Description"
                                                onChange={handleUploadInput}
                                                name="description"
                                                value={uploadFileData.description}
                                            />
                                            {descriptionValidationError && <div className="error-message">{descriptionValidationError}</div>}
                                        </Col>
                                        <Col xs={12} lg={3}>
                                            <SelectDropDown
                                                labelName="Document Type"
                                                requiredStar="*"
                                                options={documentType}
                                                setSelectedValue={setIsDocumentSelect}
                                                selectedValue={isDocumentSelect}
                                                onChange={handleDocumentTypeChange} />

                                            {documentTypeValidationError && <div className="error-message">{documentTypeValidationError}</div>}
                                        </Col>
                                        {isDocumentSelect.id !== "" &&
                                            <Col xs={12} lg={3}>
                                                <UploadFile label="Upload File"
                                                    requiredStar="*"
                                                    accept="image/*,video/*,.pdf"
                                                    value={uploadFile}
                                                    setValue={setUploadFile} />
                                                {documentValidationError && <div className="error-message pos-3">{documentValidationError}</div>}
                                            </Col>

                                        }
                                        <Col xs={12} lg={3} className={`twoBtnRow" ${isDocumentSelect.id == "" ? "mt-29" : ""}`}>
                                            <Row>
                                                <Col xs={12} lg={6}>
                                                    <PrimaryGradientButton buttonText={isButtonLoading ? "Processing..." : "Submit"} onClick={handleUpload} disabled={isButtonLoading} />
                                                </Col>
                                                <Col xs={12} lg={6}>
                                                    <PrimaryOutLineButton outlinebuttonText="View Library"  onClick={handleViewLibrary}/>
                                                </Col>
                                            </Row>
                                        </Col>

                                        <Col xs={12} lg={6} >
                                            {showAlert && (
                                                <AlertMsg
                                                    alertBoxColor={
                                                        isLoginSuccess.isSuccess
                                                            ? "successAlert"
                                                            : "FailedAlert"
                                                    }

                                                    text={isLoginSuccess.text} />)}
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default LibraryUpload